import { render } from "./WAlertDescription.vue?vue&type=template&id=56718d57"
const script = {}

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__